<template>
  <div class="px-3">
    <v-card-text class="pb-0">
      <v-form ref="formRef">
        <v-layout row wrap>
          <v-flex xs12>
            <late-info-message :overstay="1"/>

            <v-alert type="warning" class="text-uppercase">
              <b>For Regulating the overstayed visa (special case)</b>
            </v-alert>
          </v-flex>

          <v-card-text class="row pb-0">
            <v-flex sm12 md12>
              <confirmation-header-text
                  class="mx-0 mb-3"
                  :text="$vuetify.lang.t('$vuetify.select_visa_category')"
                  icon="mdi-equal-box"
              />
            </v-flex>
            <v-flex xs12 md12>
              <v-radio-group
                  row
                  class="mt-0"
                  v-model="special_overstay_regulation_condition"
              >
                <v-radio
                    class="mr-10"
                    v-for="option in special_overstay_regulation_condition_options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-card-text>

          <v-card-text
              class="row pb-0"
              v-if="special_overstay_regulation_condition == 'business-working-conversion'"
          >
            <v-card-text class="row pb-0 pt-0" v-if="extendConvertVisaDetail.slug == 'tourist-visa'">
              <v-flex sm12 md12 class="">
                <confirmation-header-text
                    class="mx-0 mb-3"
                    text="Conversion Details"
                    icon="mdi-equal-box"
                />
              </v-flex>
              <v-flex xs12 sm4>
                <v-autocomplete
                    :items="convert_visa_options"
                    :rules="[rules.required]"
                    class="pr-2"
                    item-text="type"
                    item-value="id"
                    label="Convert Visa to *"
                    outlined
                    v-model="extendConvertData.visa_type">
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm4>
                <v-autocomplete
                    :items="reason_for_conversion"
                    :label="$vuetify.lang.t('$vuetify.reason_for_convert') + ' *'"
                    :rules=[rules.required]
                    outlined
                    v-model="extendConvertData.purpose_of_visa"
                />
              </v-flex>
              <v-flex class="pl-2" xs12 sm4>
                <v-text-field
                    :rules=[rules.required,rules.mobileNumberLength]
                    label="Mobile number of Nepal *"
                    outlined
                    type="number"
                    v-model="extendConvertData.mobile_number"
                />
              </v-flex>

              <v-flex xs12
                      v-if="isDependent && !['dependent-diplomatic-visa','dependent-official-visa'].includes(visaSlug)">
                <v-checkbox class="mt-0" :value=1 v-model="extendConvertData.isIndianHost"
                            label="Is Host Indian/Nepali?"></v-checkbox>
              </v-flex>
              <v-flex
                  v-if="isDependent && (!['dependent-diplomatic-visa','dependent-official-visa'].includes(visaSlug) && extendConvertData.isIndianHost !== 1)"
                  xs6>
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.dependent_visa_number') +'*'"
                    :rules="[rules.required]"
                    class="pr-2"
                    outlined
                    type="text"
                    v-model="extendConvertData.dependent_visa_number"
                />
              </v-flex>
              <v-flex xs6 v-if="isDependent">
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.dependent_passport_number') + '*'"
                    :rules="[rules.required]"
                    class="pr-2"
                    outlined
                    type="text"
                    v-model="extendConvertData.dependent_passport_number"
                />
              </v-flex>

              <v-flex class="d-flex" xs12>
                <v-spacer></v-spacer>
                <v-btn
                    @click="back"
                    class="mr-3"
                    color="error"
                    dark
                    large
                >{{ $vuetify.lang.t('$vuetify.back') }}
                </v-btn>
                <v-btn @click="proceedConvert"
                       color="primary"
                       large
                       :loading="loading"
                >
                  {{ $vuetify.lang.t('$vuetify.proceed') }}
                </v-btn>
              </v-flex>
            </v-card-text>
            <v-card-text class="px-0 pt-0" v-else>
              <v-alert outlined type="error">
                Sorry, cannot apply for this category without tourist visa
              </v-alert>
            </v-card-text>
          </v-card-text>

          <v-card-text
              class="row pb-0"
              v-if="special_overstay_regulation_condition == 'relation-marriage-extension'"
          >
            <v-card-text class="row pb-0 pt-0"
                         v-if="['marriage-visa', 'relation-visa'].includes(extendConvertVisaDetail.slug)">
              <v-flex sm12 md12 class="">
                <confirmation-header-text
                    class="mx-0 mb-3"
                    text="Extension Details"
                    icon="mdi-equal-box"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    :items="reason_for_extension"
                    :label="$vuetify.lang.t('$vuetify.reason_for_extend') + ' *'"
                    :rules=[rules.required]
                    outlined
                    v-model="extendConvertData.purpose_of_visa"
                />
              </v-flex>

              <v-flex xs12 sm6 class="pl-2">
                <v-text-field
                    label="Mobile number in Nepal *"
                    :rules=[rules.required]
                    outlined
                    v-model="extendConvertData.mobile_number"
                />
              </v-flex>
              <v-flex xs12 sm12 md4>
                <date-picker-new
                    class="pl-3 pr-4"
                    :for-passport="true"
                    :for-processing="true"
                    v-model="extendConvertData.start_date"
                    :watch-value="true"
                    label="Visa Start Date: Day* "
                />
              </v-flex>

              <v-flex xs12 sm12 md4
                      :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pl-2': $vuetify.breakpoint.mdAndUp}"
              >
                <v-text-field
                    :rules="[rules.required]"
                    :label="$vuetify.lang.t('$vuetify.days_staying') +' *'"
                    min="0"
                    onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                    outlined
                    type="number"
                    v-model="extendConvertData.days_staying"
                />
              </v-flex>
              <v-flex xs12 sm12 md4
                      :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pl-2': $vuetify.breakpoint.mdAndUp}">
                <v-text-field
                    :rules="[rules.required]"
                    label="Visa Expiry Date *"
                    min="0"
                    outlined
                    type="text"
                    :disabled="true"
                    :value="expiryDate"
                />
              </v-flex>
              <v-flex xs12>
                <tourist-visa :for-processing="true"></tourist-visa>
              </v-flex>

              <v-flex class="d-flex" xs12>
                <v-spacer></v-spacer>
                <v-btn
                    @click="back"
                    color="error"
                    dark
                    large
                >{{ $vuetify.lang.t('$vuetify.back') }}
                </v-btn>
                <v-btn
                    class=" ml-2"
                    @click="proceedConfirm"
                    large
                    color="primary">
                  {{ $vuetify.lang.t('$vuetify.proceed') }}
                </v-btn>
              </v-flex>
            </v-card-text>
            <v-card-text class="px-0 pt-0" v-else>
              <v-alert outlined type="error">
                Sorry, cannot apply for this category without relation/marraige visa
              </v-alert>
            </v-card-text>
          </v-card-text>
        </v-layout>
      </v-form>

    </v-card-text>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

import TouristVisa from "../components/visa/form/TouristVisa";
import {validationMixin} from "../mixins/validationMixin";
import LateInfoMessage from "../components/LateInfoMessage";
import {fetchDynamicValues} from "../helpers/dynamicValueHelper";
import moment from "moment"
import DatePickerNew from "../components/DatePickerNew";
import Http from 'axios'
import {API_URL, VERSION} from "../config/config";
import {VISA_PLANS} from "../constant/appConstant";
import ConfirmationHeaderText from "../components/ConfirmationHeaderText";

export default {
  name: "OverstayRegulationSpecialForm",
  components: {
    DatePickerNew,
    LateInfoMessage,
    TouristVisa,
    ConfirmationHeaderText,
  },
  data() {
    return {
      invalid_date: false,
      show_sre: null,
      show_mre: null,
      selectedPlan: null,
      visa_plans: VISA_PLANS,
      reason_for_extension: [],
      existing_token: null,
      loading: false,
      is_special_overstay_regulation: 1,
      reason_for_conversion: [],
      special_overstay_regulation_condition: 'business-working-conversion',
      special_overstay_regulation_condition_options: [
        {
          label: this.$vuetify.lang.t('$vuetify.apply_for_business_working_conversion'),
          value: 'business-working-conversion'
        },
        {
          label: this.$vuetify.lang.t('$vuetify.apply_for_relation_marriage_extension'),
          value: 'relation-marriage-extension'
        }
      ],
    }
  },
  mixins: [validationMixin],
  methods: {
    ...mapActions({
      submitVisaExtend: "VisaSingle/submitExtendVisa",
      submitConvertVisa: "VisaSingle/submitConvertVisa",
      fetchConditionForConvert: 'VisaType/fetchConditionForConvert',
      fetchConditionsForExtend: 'VisaType/fetchConditionsForExtend',
      fetchAllCountries: "CountryForTouristList/fetchAll",
    }),
    getConditionForDependent() {
      this.$store.dispatch('VisaType/fetchConditionForDependentExtend', this.extendConvertData.extend_visa_type)
    },
    async proceedConvert() {
      if (this.$refs.formRef.validate()) {
        if ((this.extendConvertVisaDetail.passport_number === this.extendConvertData.dependent_passport_number) && (this.extendConvertVisaDetail.visa_number === this.extendConvertData.dependent_visa_number)) {
          this.$store.commit('Notification/showError', 'You cannot apply for dependent with yourself')
          return
        }

        try {
          this.loading = true;
          await this.fetchConditionForConvert({
            type: this.extendConvertData.visa_type
          });
          this.extendConvertData.is_special_overstay_regulation = this.is_special_overstay_regulation
          this.extendConvertData.special_overstay_regulation_condition = this.special_overstay_regulation_condition
          this.extendConvertData.start_date = new Date().toISOString().substr(0, 10);
          this.$router.push({
            name: 'ConvertForm'
          })
          this.loading = false
        } catch (e) {
          this.loading = false;
        }
      } else {
        this.$store.commit('Notification/showError', 'Invalid form data')
      }
    },

    async proceedConfirm() {
      if (this.$refs.formRef.validate()) {
        if (this.extendConvertVisaDetail.late_days > this.extendConvertData.days_staying) {
          this.$store.commit('Notification/showError', 'You need to apply for ' + this.extendConvertVisaDetail.late_days + ' minimum days');
          return;
        }

        this.extendConvertData.plan_name = this.plan;
        this.extendConvertData.plan = this.extendConvertData.visaPlan;
        this.extendConvertData.documents = this.documents;
        this.extendConvertData.cost = this.cost;
        this.extendConvertData.overstay_processing = 1;
        this.extendConvertData.expiry_date = this.expiryDate;
        this.$router.push({
          name: 'ExtendConfirm'
        })
      }
    },

    back() {
      this.$router.go(-1);
    },
  },
  async updated() {

    const current_token = this.extendConvertVisaDetail.access_token;
    if (this.existing_token !== current_token) {
      await this.$store.dispatch('VisaType/fetchConditionsForExtend');
      if (this.extend_condition !== undefined && this.extend_condition.length === 1) {
        this.extendConvertData.condition = this.extend_condition[0].id
      }
      this.existing_token = current_token;
    }
  },
  computed: {
    ...mapGetters('VisaType', ['conditions', 'extend_condition', 'visa_type_slug', 'old_visa']),
    ...mapGetters('VisaSingle', ['convert_visa_options', 'extendConvertVisaDetail']),
    convert_visa_options() {
      let convert_visa_options = this.$store.state.VisaSingle.convert_visa_options.filter(item => item.slug !== this.extendConvertVisaDetail.slug);
      const {slug} = this.extendConvertVisaDetail;
      if (this.overStayedOrLate && slug === 'tourist-visa') {
        return convert_visa_options.filter(i => (
            (i.slug === 'tourist-visa') ||
            (i.slug === 'business-visa') ||
            (i.slug === 'working-visa') ||
            (i.slug === 'temporary-working-visa') ||
            (i.slug === 'temporary-business-visa') ||
            (i.slug === 'dependent-business-visa') ||
            (i.slug === 'dependent-working-visa') ||
            (i.slug === 'teaching-research-visa')
        ));
      }
    },
    overStayedOrLate() {
      if (this.extendConvertVisaDetail) {
        return this.extendConvertVisaDetail.late_days > 0 || this.extendConvertVisaDetail.overstayed > 0;
      }
      return false;
    },
    extendConvertData() {
      return this.$store.state.VisaSingle.extendConvertData;
    },
    expiryDate() {
      return moment(this.extendConvertData.start_date).add(this.extendConvertData.days_staying, 'days').subtract(1, 'days').format('YYYY-MM-DD');
    },
    offices() {
      return this.$store.state.Office.offices;
    },
    showAppointment() {
      const selected_office = this.offices.find(i => i.slug === this.$store.state.VisaSingle.office)
      return selected_office.token_system_active;
    },
    condition_label() {
      let dependent_visa = this.extendConvertVisaDetail.dependent_visa ? "Dependent visa" : this.extendConvertVisaDetail.visa_type;
      return "Available condition for " + dependent_visa + " *"
    },
    documents() {
      if (this.extendConvertData.condition) {
        let selected_condition = this.extend_condition.find((i) => i.id === this.extendConvertData.condition);

        if (selected_condition)
          return selected_condition.documents;
      }
      return [];
    },
    plan() {
      if (this.extendConvertData.apply_extend_gratis)
        return "Multiple Re-entry";

      if (!this.extendConvertData)
        return false;

      if (!this.extendConvertData.visaPlan)
        return false;

      return this.visa_plans.find((i) => i.key === parseInt(this.extendConvertData.visaPlan)).value;
    },
    cost() {
      return this.extendConvertData.days_staying * 3;
    },
    message() {
      const selected_condition = this.conditions.find((c) => c.id === this.extendConvertData.condition);
      if (selected_condition) {
        return selected_condition.extension_message;
      } else {
        return false;
      }
    },
    isDependent() {
      const selected_visa_type = this.convert_visa_options.find(i => i.id === this.extendConvertData.visa_type);
      if (selected_visa_type !== undefined && selected_visa_type.dependent)
        return true

      return false
    },
    visaSlug() {
      const selected_visa_type = this.convert_visa_options.find(i => i.id === this.extendConvertData.visa_type);
      return selected_visa_type.slug;
    },
  },
  async mounted() {
    this.extendConvertData.start_date = moment(this.extendConvertVisaDetail.expiry_date).add(1, 'days').format('YYYY-MM-DD');

    fetchDynamicValues('ReasonForExtension').then((data) => {
      this.reason_for_extension = data;
    });
    fetchDynamicValues('ReasonForConversion').then((data) => {
      this.reason_for_conversion = data;
    });
  }

}
</script>
